import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const HrmPageHero: React.FC = () => {
  return (
    <section className="wdev-page-hero" aria-labelledby="hrm-hero-title">
      <div className="wdev-page-hero__bg" aria-hidden="true">
        <div className="wdev-page-hero__gradient" />
        <div className="wdev-page-hero__mesh" />
        <div className="wdev-page-hero__wave wdev-page-hero__wave--1" />
        <div className="wdev-page-hero__wave wdev-page-hero__wave--2" />
      </div>

      <div className="container wdev-page-hero__content">
        <motion.nav
          className="wdev-breadcrumb"
          aria-label="Breadcrumb"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/">Home</Link>
          <span className="wdev-breadcrumb__sep" aria-hidden="true">/</span>
          <Link to="/project">Products</Link>
        </motion.nav>

        <motion.h1
          id="hrm-hero-title"
          className="wdev-page-hero__title"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          HRM <span className="wdev-gradient-text">Software</span>
        </motion.h1>

        <motion.p
          className="wdev-page-hero__subtitle"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Human Resource Management System — automate payroll, attendance, leave, recruitment, and
          performance for your entire workforce.
        </motion.p>

        <motion.div
          className="wdev-page-hero__actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Link to="/contact" className="wdev-btn wdev-btn--primary">
            Request a Demo
            <ArrowIcon />
          </Link>
          <Link to="/project" className="wdev-btn wdev-btn--ghost">
            View All Products
            <ArrowIcon />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HrmPageHero;
